import { livingArrangementsTypes, employmentTypes } from "../../../constants";
import criteria from "../../../utils/criteria";

const { PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS } = livingArrangementsTypes;

const { SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL, BENEFITS } = employmentTypes;

const {
  assetType,
  loanAmountBetween,
  creditScoreGreaterThan,
  employmentType,
  timeOfEmploymentGreaterThan,
  livingArrangements,
  termIsLessThanOrEqualTo,
} = criteria;

const platinum = [
  {
    name: "Platinum - New/Demo",
    rate: 13.95,
    productType: "Standard",
    criteria: [
      loanAmountBetween(5000, 6000),

      termIsLessThanOrEqualTo(24),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreGreaterThan(600),
    ],
  },

  {
    name: "Platinum - New/Demo",
    rate: 13.95,
    productType: "Standard",
    criteria: [
      loanAmountBetween(6000, 8000),

      termIsLessThanOrEqualTo(36),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreGreaterThan(600),
    ],
  },

  {
    name: "Platinum - New/Demo",
    rate: 13.95,
    productType: "Standard",
    criteria: [
      loanAmountBetween(8000, 15000),

      termIsLessThanOrEqualTo(48),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreGreaterThan(600),
    ],
  },

  {
    name: "Platinum - New/Demo",
    rate: 13.95,
    productType: "Standard",
    criteria: [
      loanAmountBetween(15000, 30000),

      termIsLessThanOrEqualTo(60),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreGreaterThan(600),
    ],
  },

  {
    name: "Platinum - New/Demo",
    rate: 13.95,
    productType: "Standard",
    criteria: [
      loanAmountBetween(30000, 75000),

      termIsLessThanOrEqualTo(72),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([SELF_EMPLOYED, FULL_TIME, PART_TIME, CONTRACT, CASUAL]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreGreaterThan(600),
    ],
  },

  {
    name: "Platinum Micro - New/Demo",
    rate: 13.95,
    productType: "Standard",
    criteria: [
      loanAmountBetween(2000, 6000),

      termIsLessThanOrEqualTo(24),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([BENEFITS]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreGreaterThan(600),
    ],
  },

  {
    name: "Platinum Micro - New/Demo",
    rate: 13.95,
    productType: "Standard",
    criteria: [
      loanAmountBetween(6000, 8000),

      termIsLessThanOrEqualTo(36),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([BENEFITS]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreGreaterThan(600),
    ],
  },

  {
    name: "Platinum Micro - New/Demo",
    rate: 13.95,
    productType: "Standard",
    criteria: [
      loanAmountBetween(8000, 12000),

      termIsLessThanOrEqualTo(48),
      livingArrangements([PROPERTY_OWNER, RENTING, BOARDING, LIVING_WITH_PARENTS]),
      employmentType([BENEFITS]),
      timeOfEmploymentGreaterThan(6),
      assetType([
        "Motor Vehicle",
        "Electric Motor Vehicle",
        "Caravan",
        "Trailered boat",
        "Motorbike",
        "Horse float",
        "Ride on mower",
        "Jetski/PWC",
        "ATV/Off-Road Bike",
      ]),

      creditScoreGreaterThan(600),
    ],
  },
];
export default platinum;
